var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "container", attrs: { type: "flex" } },
        [
          _c("app-card-dashboard", {
            style: { marginLeft: 0 },
            attrs: {
              title: "Total de processos de arrecadação",
              content: this.dadosCards.quantidadeTotal || "0",
              color: "red",
              marginTop: 0
            }
          }),
          _c("app-card-dashboard", {
            style: { marginLeft: 0 },
            attrs: {
              title: "Processos em arrecadação",
              content: this.dadosCards.quantidadeEmArrecadacao || "0",
              color: "yellow",
              marginTop: 0
            }
          }),
          _c("app-card-dashboard", {
            style: { marginLeft: 0 },
            attrs: {
              title: "Processos de arrecadação concluídos",
              content: this.dadosCards.quantidadeArrecadada || "0",
              color: "#3d9c67",
              marginTop: 0
            }
          })
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "container", attrs: { type: "flex" } },
        [
          _c("card-area", {
            attrs: {
              title: "Total de áreas",
              value: this.dadosCards.areaTotal || 0
            }
          }),
          _c("card-area", {
            attrs: {
              title: "Áreas em arrecadação",
              value: this.dadosCards.areaTotalEmArrecadacao || 0
            }
          }),
          _c("card-area", {
            attrs: {
              title: "Áreas arrecadadas",
              value: this.dadosCards.areaTotalArrecadada || 0
            }
          })
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "container-grafico" },
        [
          _c("h3", [_vm._v("Gráfico")]),
          _c("abas-grafico", {
            on: {
              tabChanged: function($event) {
                return _vm.alterarGrafico($event)
              }
            }
          }),
          _c("filtro-relatorios", {
            on: {
              filtrar: function($event) {
                return _vm.filtrar($event)
              },
              limpar: function($event) {
                return _vm.limpar()
              }
            }
          }),
          this.abaAtiva === "PERIODO"
            ? _c(
                "div",
                {
                  staticClass: "container",
                  attrs: { id: "opcoes-periodo", type: "flex" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "opcao-periodo",
                      attrs: { id: "day" },
                      on: {
                        click: function($event) {
                          return _vm.changeTipoData("diario")
                        }
                      }
                    },
                    [_c("span", [_vm._v("Diário")])]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "opcao-periodo",
                      attrs: { id: "month" },
                      on: {
                        click: function($event) {
                          return _vm.changeTipoData("mensal")
                        }
                      }
                    },
                    [_c("span", [_vm._v("Mensal")])]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "opcao-periodo",
                      attrs: { id: "year" },
                      on: {
                        click: function($event) {
                          return _vm.changeTipoData("anual")
                        }
                      }
                    },
                    [_c("span", [_vm._v("Anual")])]
                  )
                ]
              )
            : _vm._e(),
          _vm.showGrafico
            ? _c("grafico", {
                style: { "box-shadow": "0 2px 12px 0 rgba(0, 0, 0, 0.1)" },
                attrs: {
                  idDiv: "sample",
                  dados: _vm.dadosGrafico,
                  keyX: "dadoNominal",
                  keyY: "dadoQuantitativo",
                  keyText: "quantidade",
                  showTituloGrafico: false,
                  tituloX: this.tituloX,
                  tituloY: this.tituloY,
                  cores: this.cores,
                  switchText: this.switchText
                }
              })
            : _vm._e(),
          !_vm.showGrafico
            ? _c(
                "el-row",
                { staticClass: "tableContainer" },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: {
                        padding: "30px",
                        overflow: "auto",
                        height: "400px"
                      },
                      attrs: { data: _vm.dadosGraficoTabela }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "dadoNominal", label: this.tituloX }
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "dadoQuantitativo", label: this.tituloY }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-row",
            { attrs: { type: "flex" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.showGrafico,
                    callback: function($$v) {
                      _vm.showGrafico = $$v
                    },
                    expression: "showGrafico"
                  }
                },
                [
                  _c("el-radio-button", { attrs: { label: true } }, [
                    _vm._v("Gráfico")
                  ]),
                  _c("el-radio-button", { attrs: { label: false } }, [
                    _vm._v("Tabela")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "container-switch", attrs: { type: "flex" } },
            [
              _c("span", [_vm._v("Por quantidade de processos")]),
              _c("el-switch", {
                attrs: {
                  "active-color": "#4dd863",
                  "inactive-color": "#a7a7a7"
                },
                model: {
                  value: _vm.switchValue,
                  callback: function($$v) {
                    _vm.switchValue = $$v
                  },
                  expression: "switchValue"
                }
              }),
              _c("span", { staticClass: "areaSpan" }, [
                _vm._v("Por área (em ha)")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", id: "export-button" },
                  on: { click: _vm.exportar }
                },
                [_vm._v("Exportar")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "container-grafico", staticStyle: { marginTop: "3%" } },
        [
          _c("h3", [_vm._v("Processos")]),
          _c("filtro-relatorios", {
            attrs: { showNumeroProcesso: true },
            on: {
              filtrar: function($event) {
                return _vm.filtrarProcessos($event)
              },
              limpar: function($event) {
                return _vm.limparProcessos()
              }
            }
          }),
          _c("h3", { staticStyle: { marginTop: "1%", marginLeft: "1%" } }, [
            _vm._v("Listagem de Processos")
          ]),
          _c("table-generica", {
            attrs: {
              colunas: _vm.colunas,
              botoesAcao: _vm.botoesAcao,
              dados: _vm.processos,
              sortChanged: _vm.sortChanged
            }
          }),
          _c(
            "el-row",
            {
              staticClass: "container-switch",
              staticStyle: { marginTop: "1%" },
              attrs: { type: "flex" }
            },
            [
              _c("app-paginacao", {
                attrs: { total: _vm.totalProcessos, pagina: _vm.pagina },
                on: {
                  changePage: function($event) {
                    return _vm.changePage($event)
                  }
                }
              }),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", id: "export-button" },
                  on: { click: _vm.exportarProcessos }
                },
                [_vm._v("Exportar")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.showModal
        ? _c(
            "app-modal",
            {
              attrs: { titulo: "Visualizar processo" },
              on: {
                closeModal: function($event) {
                  _vm.showModal = false
                }
              }
            },
            [
              _c(
                "template",
                { slot: "body" },
                [
                  _c("analise-processo", {
                    attrs: {
                      routeListagemName: "arrecadacao/relatorios",
                      isVisualizar: true,
                      idProcesso: this.idProcessoSelecionado
                    }
                  })
                ],
                1
              )
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51bf2fc2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51bf2fc2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/relatorios/Home.vue
// module id = null
// module chunks = 